import type { App } from 'vue';
import PrimeVue, { type PrimeVueConfiguration } from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

const preset = definePreset(Aura, {
  components: {
    dialog: {
      root: {
        background: '#0000',
        borderColor: '#0000',
        color: 'inherit',
        shadow: 'none',
      },
      header: {
        padding: 'none',
      },
      footer: {
        padding: 'none',
      },
      content: {
        padding: 'none',
      },
      css: () => `
            .p-dialog-mask {
                color: inherit
            }
            `,
    },
    toast: {
      info: {
        color: 'inherit',
      },
      root: {},
      content: {
        padding: '1rem ',
      },
      detail: {},
      colorScheme: {
        dark: {
          info: { borderColor: 'var(--color-grand-text)' },
        },
        light: {},
      },
    },
  },
});
const option: PrimeVueConfiguration = {
  theme: {
    preset: preset,
    darkModeSelector: false,
  },
};
// defaultOptions.
export default (app: App) => {
  app.use(PrimeVue, option);
};
